import React from 'react';

import css from './styles.css';

const AlertBadge = () => <div className={css.dot} />;

export default AlertBadge;
